import { render, staticRenderFns } from "./GridInnerConfig.vue?vue&type=template&id=67292dda&"
import script from "./GridInnerConfig.vue?vue&type=script&lang=js&"
export * from "./GridInnerConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports